import CloseIcon from '@mui/icons-material/Close'
import SearchIcon from '@mui/icons-material/Search'

import LocalStorageButtons from '@components/LocalStorageButtons'
import FilterGridContainer from '@components/toolbar/FilterGridContainer'
import FilterGridItem from '@components/toolbar/FilterGridItem'
import { FilterSelectGebied } from '@components/toolbar/FilterSelectGebied'
import type { Gebied } from '@models/Gebied'

import { SelectString } from '../../../../core/components/SelectString'
import { useLocalFilters } from '../../../../core/hooks/useLocalFilters'
import { StyledIconButton } from '../../../../theme/components/StyledIconButton'
import { queryKey } from '../../hooks/useWerkbakken'
import type { FetchWerkbakkenFilters } from '../../types/FetchWerkbakken'

interface Props {
  filters: FetchWerkbakkenFilters
  initialFilters: FetchWerkbakkenFilters
  onChange: (filters: FetchWerkbakkenFilters) => void
  onReset: () => void
  onRefresh: () => void
  filterOptions: {
    netbeheerders: string[]
    uitvoerendeAannemers: string[]
    gebieden: Gebied[]
  }
}

export const WerkbakkenFilters = ({
  filters,
  initialFilters,
  onChange,
  onRefresh,
  onReset,
  filterOptions: { netbeheerders, uitvoerendeAannemers, gebieden },
}: Props) => {
  const { localFilters, handleFilterChange, handleZoeken, handleReset } =
    useLocalFilters({
      filters,
      initialFilters,
      onChange: (filters) => onChange(filters),
      onRefresh,
      onReset,
    })

  return (
    <FilterGridContainer>
      <FilterGridItem>
        <FilterSelectGebied
          options={gebieden}
          value={localFilters.gebied}
          onFilterChange={handleFilterChange}
        />
      </FilterGridItem>

      {/* If there is only 1 netbeheerder, hide the list. It's unnecessary to display it */}
      {netbeheerders.length > 1 && (
        <FilterGridItem>
          <SelectString
            options={netbeheerders}
            label="Netbeheerder"
            value={localFilters.netbeheerder}
            onChange={(value) => handleFilterChange({ netbeheerder: value })}
          />
        </FilterGridItem>
      )}

      {uitvoerendeAannemers.length > 1 && (
        <FilterGridItem>
          <SelectString
            options={uitvoerendeAannemers}
            label="Aannemer"
            value={localFilters.aannemer}
            onChange={(value) => handleFilterChange({ aannemer: value })}
          />
        </FilterGridItem>
      )}

      <FilterGridItem
        minColumns="full"
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
        }}
      >
        <StyledIconButton
          icon={<CloseIcon />}
          title="Reset filters"
          onClick={() => handleReset()}
        />
        <StyledIconButton
          icon={<SearchIcon />}
          title="Zoeken"
          onClick={() => handleZoeken()}
        />

        <LocalStorageButtons
          name={queryKey}
          storable={localFilters}
          onClickLoad={handleFilterChange}
        />
      </FilterGridItem>
    </FilterGridContainer>
  )
}
